"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Dev;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Dev(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Brands",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "dev"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline",
    d: "M33.121,69.912a2.479,2.479,0,0,1-1.437-.456L6.061,51.412a2.5,2.5,0,0,1,0-4.088L31.684,29.28a2.5,2.5,0,0,1,2.878,4.088l-22.72,16,22.72,16a2.5,2.5,0,0,1-1.441,4.544Zm1.311-32.236a1.5,1.5,0,0,0-2.086-.387L16.575,48.132a1.5,1.5,0,0,0,0,2.472L32.346,61.448a1.5,1.5,0,1,0,1.7-2.472L20.072,49.368l13.973-9.606A1.5,1.5,0,0,0,34.432,37.676Zm59.507,9.648L68.316,29.281a2.5,2.5,0,0,0-2.879,4.088l22.721,16-22.721,16a2.5,2.5,0,0,0,2.879,4.088L93.939,51.412a2.5,2.5,0,0,0,0-4.088ZM65.568,61.062a1.5,1.5,0,0,0,2.086.386L83.425,50.6a1.5,1.5,0,0,0,0-2.472L67.654,37.289a1.5,1.5,0,0,0-1.7,2.473l13.973,9.606L65.955,58.976A1.5,1.5,0,0,0,65.568,61.062ZM51.779,35.926a2.493,2.493,0,0,0-3.239,1.415l-14.2,36.224A2.5,2.5,0,1,0,39,75.39l14.2-36.225A2.5,2.5,0,0,0,51.779,35.926ZM63.612,23.2a2.494,2.494,0,0,0-3.239,1.415l-14.2,36.225a2.5,2.5,0,1,0,4.654,1.824l14.2-36.224A2.5,2.5,0,0,0,63.612,23.2Z"
  })));
}